import { Injectable } from '@angular/core';
import { LocalService } from './local.service';
import { User } from '../../shared/model/auth.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(
    private localService: LocalService,
  ) { }

  getApiUrl(service: string, url: string): string {
    // if (service.includes('recruitment-http') && !url.includes('auth')) {
    //   return `http://localhost:3001/${service}/${url}`;
    // }
    return this.localService.getData('api.url') + '/' + service + '/' + url;
  }

  getStage(): string {
    return this.localService.getData('stage') || 'prod';
  }

  getToken(real = false): string {
    return this.localService.getData(real ? 'auth.token_real' : 'auth.token');
  }

  getUser(): User {
    return JSON.parse(this.localService.getData('auth.user'));
  }

  getInitials(fullName?: string): string {
    const user = this.getUser();
    const fixedName = fullName || user?.full_name;

    if (fixedName) {
      const allInitials = fixedName.split(' ').map((name: string) => name.charAt(0).toUpperCase()).join('');
      return allInitials.length > 2 ? allInitials.substring(0, 2) : allInitials;
    }

    return 'XX';
  }

  getTenantUuid(): string {
    return this.localService.getData('tenant.uuid');
  }

  getLogo(): string {
    return this.localService.getData('tenant.logo') || 'https://files.sokrates.co.id/sokrates.png';
  }
  
  getBanner(): string {
    return this.localService.getData('tenant.banner') || null;
  }

  getPermissions(): Record<string, boolean> {
    return JSON.parse(this.localService.getData('auth.permissions')) || {};
  }

  getS3Url(path: string): string {
    if (!path) return null;
    if (!path.startsWith('/')) {
      path = '/' + path;
    }
    return this.localService.getData('s3.url') + path;
  }

  setToken(token: string, real = false): void {
    this.localService.saveData(real ? 'auth.token_real' : 'auth.token', token);
  }

  setUser(data: User): void {
    this.localService.saveData('auth.user', JSON.stringify(data));
  }

  setPermissions(data: Record<string, boolean>): void {
    this.localService.saveData('auth.permissions', JSON.stringify(data));
  }

  isLoggedIn(): boolean {
    return this.localService.getData('auth.token') !== null;
  }

  getExportUrl(): string {
    return this.localService.getData('export.url');
  }
}
